<mat-dialog-content>
  <div class="row mb-2">
    <div>
      <div class="col-4">
        <label>Nova anotação</label>
        <textarea
          class="form-control"
          style="width: 700px"
          data-cy="newComment"
          rows="5"
          maxlength="1000"
          name="newComment"
          [(ngModel)]="newComment"
        >
        </textarea>
        <span class="text-right" *ngIf="newComment != null"
          >{{ newComment.length }}/1000 caracteres</span
        ><br />
      </div>
    </div>
  </div>

  <button style="width: 150px" (click)="saveComments()">
    <span>Salvar</span>
  </button>

  <div class="row col-md-12" *ngFor="let item of commentList">
    <div class="form-group">
      <label
        >Usuario: {{ item.user }} Status da Boleta:
        {{ item.workflowStatus }} Data:
        {{ item.creationDate | date: "dd/MM/yyyy hh:mm:ss" }}</label
      >
      <textarea
        class="form-control"
        [(ngModel)]="item.comment"
        style="width: 700px"
        data-cy="item.comment"
        rows="5"
        maxlength="1000"
        name="briefOperation"
      >
      </textarea>
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Fechar</button>
  </mat-dialog-actions>
</mat-dialog-content>
